import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SeguimientoPdesService {

  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  private headerFile(accessToken: string) {
    let headers = new HttpHeaders({
      //"Content-Type": "multipart/form-data",
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken,
    });
    headers.append("enctype", "multipart/form-data");
    return headers;
  }

  getIndicadorUser(user_id: number, mesId: number): Observable<any> {
    return this, this.http.get(this.baseUrl + 'indicadorUser/' + user_id + '/' + mesId, { headers: this.header(this.token) });
  }

  getIndicadoresPdes(): Observable<any> {
    return this, this.http.get(this.baseUrl + 'indicadoresPdes', { headers: this.header(this.token) });
  }

  getIndicadorPdesById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'indicadorPdesById/' + id, { headers: this.header(this.token) });
  }

  getMetaProgramada(id: string, mes_id: number): Observable<any> {
    return this, this.http.get(this.baseUrl + 'metaProgramadaXmesPdes/' + id + '/' + mes_id, { headers: this.header(this.token) });

  }

  getUsuarios(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'getUsuarios/' + id, { headers: this.header(this.token) });
  }

  postUsuariosIndicador(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'postUsuariosIndicador', bodyString, { headers: this.header(this.token) });
  }


  postReportarMes(data: any, file: any): Observable<any> {
    const fd: FormData = new FormData();
    fd.append('file', file);
    fd.append('variable_id', data.variable_id);
    fd.append('mes_id', data.mes_id);
    fd.append('valor_variable', data.valor_variable);
    fd.append('medio_verificacion', data.medio_verificacion);
    fd.append('justificacion', data.justificacion);
    fd.append('resultados_esperados', data.resultados_esperados);

    return this.http.post(this.baseUrl + 'reportarPdesMes', fd, { headers: this.headerFile(this.token) });
  }

  putReportarMes(data: any, file: any): Observable<any> {

    const fd: FormData = new FormData();
    fd.append('file', file);
    fd.append('id', data.id);
    fd.append('variable_id', data.variable_id);
    fd.append('mes_id', data.mes_id);
    fd.append('valor_variable', data.valor_variable);
    fd.append('medio_verificacion', data.medio_verificacion);
    fd.append('justificacion', data.justificacion);
    fd.append('resultados_esperados', data.resultados_esperados);   
     
    return this.http.post(this.baseUrl + 'reportarPdesMesUpdate', fd, { headers: this.headerFile(this.token) });
  }

  putActualizarEstadoSeguimiento(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'actualizarEstadoSeguimientoAlPdes', bodyString, { headers: this.header(this.token) });
  }

  putObservarSeguimiento(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'observarSeguimientoPdes', bodyString, { headers: this.header(this.token) });
  }


  getVariableMesById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'variableMesByIdPdes/' + id, { headers: this.header(this.token) });
  }

  deleteSeguimiento(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'eliminarReportado/' + id, { headers: this.header(this.token) });
  }

  
  getListaMeses(): Observable<any> {
    return this.http.get(this.baseUrl + 'listaMeses', { headers: this.header(this.token) });
  }

  putMesDia(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'mesDia', bodyString, { headers: this.header(this.token) });
  }

  getMesDeReporte(): Observable<any> {
    return this.http.get(this.baseUrl + 'mesDeReporte', { headers: this.header(this.token) });
  }

  getDiaDeReporte(): Observable<any> {
    return this.http.get(this.baseUrl + 'diaDeReporte', { headers: this.header(this.token) });
  }

  /*






  getVariablesMesByTechoId(id: string): Observable<any> {
    return this, this.http.get(this.baseUrl + 'variablesMesByTechoId/' + id, { headers: this.header(this.token) });

  }

  getIndicadoresOperacionByTechoId(techoId: string, mesId: number): Observable<any> {
    return this, this.http.get(this.baseUrl + 'indicadoresOperacionByTechoId/' + techoId + '/' + mesId , { headers: this.header(this.token) });
  }
  getVariableMesByEstadoId(techoId: string, id: string): Observable<any> {
    return this, this.http.get(this.baseUrl + 'variableMesByEstadoId/' + techoId + '/' + id, { headers: this.header(this.token) });
  }

  getListEstados(): Observable<any> {
    return this, this.http.get(this.baseUrl + 'listEstados', { headers: this.header(this.token) });
  }


  getIndicadoresOpByOperacionId(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'indicadoresOpByOperacionId/' + id, { headers: this.header(this.token) });
  }

  

 


 

 

  getRptSeguimiento(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'getSeguimientoPOA', bodyString, { headers: this.header(this.token) });
  }*/
  
}
